<template>
  <div style="height: 100%; overflow: auto">
    <h5>{{ bdtns_no }}</h5>
    <table class="tablet">
      <tr v-for = "line in tablet_content" 
      v-bind:key="line[1]"
      v-bind:class="{'highlighted': highlights.includes(line[1])}">
        <td>{{ line[1] }}</td>
        <td>{{ line[2]+' '+line[3]+' '+line[4] }}</td>
        <td>{{ line[5] }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import axios from 'axios'
  
  export default {
    data () {
      return {
        tablet_content: '',
      }
    },

    props: [
      'bdtns_no',
      'highlights'
    ],

    watch: {
      bdtns_no: function (val) {
        this.tablet_content = [];
        axios.post("http://localhost:8081/bdtns", { bdtns_no: val })
          .then(response => {
            const lines = response.data.trim().split('\n');
            this.tablet_content = lines.map(line => line.split('\t'));
          })
          .catch(e => {console.log(e)})
      }
    }
  }
</script>

<style>
table.tablet {
  border-collapse: separate;
  border-spacing: 10px 0px;
}

tr.highlighted {
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/BDTNSView.vue